import React, { useEffect, useState } from "react";
import { Button, Modal, Container, Spinner, Row } from "react-bootstrap";
import ApiService from "../../ApiService";
import AddNewTest from "./AddNewTest";
import EditTest from "./EditTest";
import { parseAxiosError } from "../../util/parserHelper";
import { BsPlus } from "react-icons/bs";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { CircularProgress } from '@material-ui/core';
import InfoIcon from "../Common/InfoIcon/InfoIcon";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const CreateTestResultModal = props => {
  const [dynamicForms, setDynamicForm] = useState([]);
  const [dynamicFormComps, setDynamicFormComps] = useState([]);
  const [error, setError] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [uploadedS3FileUrl, setUploadedS3FileUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isUploadInprogress, setIsUploadInprogress] = useState(false);

  const [snackOpen, setSnackOpen] = useState(false);
  const [snackSeverity, setSnackSeverity] = useState("");
  const [snackText, setSnackText] = useState("");

  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity);
    setSnackText(text);
    setSnackOpen(true);
  };

  const handleSnackClose = () => {
    setSnackOpen(false);
  };

  useEffect(() => {
    setUploadedS3FileUrl(null);
  }, []);

  const fetchTestInformationByKitId = async () => {
    if (props.kitId) {
      try {
        const kitData = await ApiService.getTestDataByKitId(props.kitId);
        setDynamicForm(kitData.data);
        setError(false);
      } catch (err) {
        setErrorMessage("Error fetching test information.");
        setError(true);
      }
    }
  };

  const removeTest = index => {
    let forms = [...dynamicForms];
    forms = forms.filter((fm, _index) => _index != index);
    setDynamicForm(forms);
  };

  const handleFileChange = event => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleFileUpload = async () => {
    if (!selectedFile) {
      return;
    }
    setErrorMessage("");
    setSuccessMessage("");
    setIsUploadInprogress(true);
    try {
      await ApiService.uploadCddTestResultPdf(props.kitId, selectedFile).then(resp => {
        const { fileS3Url } = resp.data;
        setUploadedS3FileUrl(fileS3Url);
        setSuccessMessage("Upload success");
        handleSnackOpen("Upload success", "success");
      });
    } catch (err) {
      setErrorMessage(`Upload failed, cause: ${parseAxiosError(err)?.message ?? "unknown"}`);
      handleSnackOpen(`Upload failed, cause: ${parseAxiosError(err)?.message ?? "unknown"}`, "error");
    } finally {
      setIsUploadInprogress(false);
    }
  };

  const updateTestValue = (index, testValue) => {
    let testForms = [...dynamicForms];
    var targetForm = testForms[index];
    targetForm.testValue = testValue;
    setDynamicForm(testForms);
  };

  const createTestResult = async () => {
    const dynamicFormsVal = [...dynamicForms];
    let resultData = dynamicFormsVal.map(form => {
      delete form.newTest;
      if (!form.hasOwnProperty("testValue")) {
        form.testValue = "";
      }
      return form;
    });
    const payload = {
      kitId: props.kitId,
      resultData,
      resultFileS3Url: uploadedS3FileUrl
    };
    try {
      setError(false);
      await ApiService.createTestResult(payload);
      props.handleClose(true);
    } catch (err) {
      const msg = err?.response?.data?.message ?? "Error creating test";
      setError(false);
      setErrorMessage(msg);
      alert(msg);
    }
  };
  const addANewTest = async testValue => {
    if (testValue) {
      const newForms = [...dynamicForms, testValue];
      setDynamicForm(newForms);
    }
  };
  const renderForm = () => {
    let dynamicFormComps = [];
    dynamicForms.forEach((test, index) => {
      dynamicFormComps.push(
        <EditTest
          testName={test.testName}
          testValue={test.testValue}
          newTest={test.newTest}
          remove={removeTest}
          index={index}
          options={test.options}
          updateValue={updateTestValue}
        />
      );
    });
    setDynamicFormComps(dynamicFormComps);
  };
  useEffect(() => {
    fetchTestInformationByKitId();
  }, [props.kitId]);
  useEffect(() => {
    renderForm();
  }, [dynamicForms]);
  return (
    <>
      <Snackbar open={snackOpen} autoHideDuration={5500} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={handleSnackClose} severity={snackSeverity}>
          {snackText}
        </Alert>
      </Snackbar>

      {isLoading && (
        <Row>
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </Row>
      )}

      <Modal
        className="create-test-result-modal"
        keyboard={false}
        onClick={e => e.stopPropagation()}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={props.show}
      >
        <Modal.Header id="modalHeader">
          <Modal.Title>Create Test Report</Modal.Title>
        </Modal.Header>
        <Modal.Body id="modalBody">
          <div class="test-form">
            {!error ? (
              <div>
                <Container className="test-list">{dynamicFormComps}</Container>
                <AddNewTest addNewTest={addANewTest} />
              </div>
            ) : (
              <div className="message">{errorMessage}</div>
            )}
            <hr />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <label className="file-picker-label">
                <input type="file" onChange={handleFileChange} className="file-picker-input" />
                <span className="file-picker-button">Choose Result file</span>
                  {selectedFile ? <span className="file-name">{selectedFile.name}</span> : <span className="file-name">Select result PDF to upload</span>}
                <InfoIcon className="file-picker-label-icon" tooltipText={"This result pdf will be available to download in patient portal after results are released"} />
              </label>


              <Button  id="msg_reply" class="replyButton sendButton text-right" onClick={handleFileUpload} disabled={isUploadInprogress}>
                {isUploadInprogress ? <CircularProgress size={15} color="inherit" /> : "Upload"}
              </Button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={e => props.handleClose(false)}>
            Cancel
          </Button>
          <Button id="msg_reply" class="replyButton sendButton text-right" onClick={createTestResult} disabled={error}>
            Submit Result <i class="fa fa-paper-plane" aria-hidden="true"></i>
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreateTestResultModal;
